import React from 'react'

import { BuildingV2 } from 'Containers/pages/'
import PropTypes from 'prop-types'
import {
  _ProjectInfoContainer,
  _LeftContainer,
  _RightContainer,
  _DetailsContainer,
  _BuildingLink,
  _BuildingImage,
} from './styles'

const ProjectInfo = ({
  googleAnalyticsEvent,
  building,
}) => {
  const handleBuildingLinkClick = () => {
    googleAnalyticsEvent({
      category: 'Precon Listing',
      action: '[Building Info, Building Link Click]',
    })
  }

  const occupancyDate = building?.dates?.find((date) => date?.type === 'Occupancy')?.exact_date

  return (
    <_ProjectInfoContainer>
      <_LeftContainer>
        <_BuildingImage src={building?.main_photo} alt={building?.name} width={640} height={480} />
      </_LeftContainer>
      <_RightContainer>
        <div>
          <h2>
            <_BuildingLink
              onMouseEnter={() => {
                BuildingV2.preload()
              }}
              to={'/' + building?.url}
              componentData={{ component: 'Building', id: building?.id }}
              onClick={handleBuildingLinkClick}
            // eslint-disable-next-line react/no-unstable-nested-components
              mobileModalChildren={({ closeModalPage }) => (
                <BuildingV2
                  buildingId={building?.id}
                  modalBuildingData={building}
                  closeModalPage={closeModalPage}
                />
              )}
              mobileModalKey={`buildingModal-${building?.id}`}
            >
              {building?.name}
            </_BuildingLink>
          </h2>
        </div>
        <_DetailsContainer>
          <div className="address">{building?.address_name}</div>
          <div><span>Construction Status:</span> {building?.construction_status || '-'}</div>
          <div><span>Selling Status:</span> {building?.sales_status || '-'}</div>
          <div><span>Occupancy:</span> {occupancyDate || '-'}</div>
        </_DetailsContainer>
      </_RightContainer>
    </_ProjectInfoContainer>
  )
}

ProjectInfo.propTypes = {
  googleAnalyticsEvent: PropTypes.func,
  building: PropTypes.shape({
    id: PropTypes.number,
    url: PropTypes.string,
    main_photo: PropTypes.string,
    name: PropTypes.string,
    address_name: PropTypes.string,
    construction_status: PropTypes.string,
    sales_status: PropTypes.string,
    dates: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      exact_date: PropTypes.string,
    })),
  }),
}

export default ProjectInfo
